import classnames from 'classnames';
import { VODCSSModules } from 'shared/utils/wix-connect';
import styles from './animate.styl';


// TODO: can be moved to shared
@VODCSSModules(styles)
export default class Animate extends React.Component {
  static propTypes = {
    className: React.PropTypes.string,
    activeClassName: React.PropTypes.string,

    children: React.PropTypes.any,
    when: React.PropTypes.bool,
    type: React.PropTypes.oneOf([
      'fade-in',
      'fade-in-out',
    ]),
  };

  render() {
    const {
      type = 'fade-in',
      children,
      when,
      className,
      activeClassName,
    } = this.props;

    if (!children) {
      return null;
    }

    const styleNames = classnames(type, { active: when });
    const classNames = classnames(className, { [activeClassName]: when });

    return (
      <div className={classNames}
           styleName={styleNames}>
        {children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/views/desktop/compact/components/animate/animate.js